import { baseApi } from './baseApi';

export interface SalesIndicators {
  presentacionPresencial: number; presentacionVirtual: number; pcHighTicket: number;
  captacionPublicado: number; captacionHighTicket: number; visitas: number;
  ofertas: number; boletosReserva: number; ventas: number;
}
export interface RentalIndicators {
  publicados: number; publicadosHighTicket: number; visitas: number;
  reservadoSenado: number; firmado: number; firmadoHighTicket: number;
}
export interface DailyIndicator {
  _id: string; agentId: string; officeId?: string;
  operationalDate: string; windowStart: string; windowEnd: string;
  sales: SalesIndicators; rentals: RentalIndicators;
  status: 'pending' | 'submitted'; via: 'form' | 'gustavo';
  submittedAt?: string; createdAt: string; updatedAt: string;
}
export interface EvidenceItem { title: string; subtitle?: string; date?: string; highTicket?: boolean; address?: string; type?: string; image?: string; link?: string }
export type Evidence = Record<string, EvidenceItem[]>;
export interface TodayPreview {
  operationalDate: string; windowStart: string; windowEnd: string;
  sales: SalesIndicators; rentals: RentalIndicators; evidence: Evidence;
  reportId: string | null; status: 'pending' | 'submitted' | null;
  /** Domingo: el parte es opcional. Se puede enviar igual, pero no se reclama. */
  isSunday?: boolean;
}

export const dailyIndicatorsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPendingIndicators: build.query<DailyIndicator[], void>({
      query: () => '/daily-indicators/pending',
      transformResponse: (r: { data: DailyIndicator[] }) => r.data,
      providesTags: (res) =>
        res ? [...res.map((i) => ({ type: 'DailyIndicator' as const, id: i._id })), { type: 'DailyIndicator' as const, id: 'PENDING' }] : [{ type: 'DailyIndicator' as const, id: 'PENDING' }],
    }),
    getTodayIndicator: build.query<TodayPreview, void>({
      query: () => '/daily-indicators/today',
      transformResponse: (r: { data: TodayPreview }) => r.data,
      providesTags: [{ type: 'DailyIndicator', id: 'TODAY' }],
    }),
    getMyIndicators: build.query<DailyIndicator[], void>({
      query: () => '/daily-indicators/mine',
      transformResponse: (r: { data: DailyIndicator[] }) => r.data,
      providesTags: (res) =>
        res ? [...res.map((i) => ({ type: 'DailyIndicator' as const, id: i._id })), { type: 'DailyIndicator' as const, id: 'LIST' }] : [{ type: 'DailyIndicator' as const, id: 'LIST' }],
    }),
    getIndicatorEvidence: build.query<Evidence, string>({
      query: (id) => `/daily-indicators/${id}/evidence`,
      transformResponse: (r: { data: Evidence }) => r.data,
      providesTags: (_r, _e, id) => [{ type: 'DailyIndicator', id: `EV-${id}` }],
    }),
    submitIndicator: build.mutation<DailyIndicator, { id: string; submit?: boolean }>({
      query: ({ id, submit }) => ({ url: `/daily-indicators/${id}`, method: 'PUT', body: { submit } }),
      transformResponse: (r: { data: DailyIndicator }) => r.data,
      invalidatesTags: (_r, _e, { id }) => [{ type: 'DailyIndicator', id }, { type: 'DailyIndicator', id: 'PENDING' }, { type: 'DailyIndicator', id: 'LIST' }],
    }),
    submitToday: build.mutation<DailyIndicator, void>({
      query: () => ({ url: '/daily-indicators/today/submit', method: 'POST' }),
      transformResponse: (r: { data: DailyIndicator }) => r.data,
      invalidatesTags: [{ type: 'DailyIndicator', id: 'TODAY' }, { type: 'DailyIndicator', id: 'PENDING' }, { type: 'DailyIndicator', id: 'LIST' }],
    }),
    createPresentation: build.mutation<unknown, { customerId: string; date?: string; modality: 'presencial' | 'virtual'; highTicket?: boolean; propertyId?: string }>({
      query: (body) => ({ url: '/daily-indicators/presentation', method: 'POST', body }),
      invalidatesTags: [{ type: 'DailyIndicator', id: 'PENDING' }, { type: 'DailyIndicator', id: 'TODAY' }],
    }),
  }),
});

export const {
  useGetPendingIndicatorsQuery,
  useGetTodayIndicatorQuery,
  useGetMyIndicatorsQuery,
  useGetIndicatorEvidenceQuery,
  useSubmitIndicatorMutation,
  useSubmitTodayMutation,
  useCreatePresentationMutation,
} = dailyIndicatorsApi;
